import type { ChatMessage } from '../types/chat'
import { isBinaryConfirmNoPhrase, isBinaryConfirmYesPhrase } from './binaryConfirmPhrase'
import { hasPendingNoteConfirmation } from './noteTaskWorkflow'

export function parseNoteConfirmAnswer(text: string): 'yes' | 'no' | null {
  if (isBinaryConfirmYesPhrase(text)) return 'yes'
  if (isBinaryConfirmNoPhrase(text)) return 'no'
  return null
}

export function findPendingNoteConfirm(messages: readonly ChatMessage[]): ChatMessage | null {
  if (!hasPendingNoteConfirmation(messages)) return null
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.historySnapshot) continue
    if (m.role !== 'assistant') continue
    if (m.awaitingNoteConfirmation && m.notePreview && !m.notePreviewResolved) return m
  }
  return null
}

export function markNoteConfirmResolved(messages: ChatMessage[], messageId?: string): ChatMessage[] {
  return messages.map((m) => {
    if (!m.awaitingNoteConfirmation || m.notePreviewResolved || m.noteConfirmed || m.noteCancelled) {
      return m
    }
    if (messageId && m.id !== messageId) return m
    return {
      ...m,
      awaitingNoteConfirmation: false,
      notePreviewResolved: true,
    }
  })
}

export function shouldUseHostedChatForNoteConfirm(
  text: string,
  messages: readonly ChatMessage[],
): boolean {
  if (!findPendingNoteConfirm(messages)) return false
  return parseNoteConfirmAnswer(text) !== null
}
